import i18n from "@/i18n";

/**
 * Traduz um campo do banco de dados usando a chave de tradução
 * @param {string} translationKey - Chave de tradução (ex: database.perfisUsuarios.administrador)
 * @param {string} fallbackValue - Valor em português para fallback
 * @returns {string} - Valor traduzido
 */
export default function translateDbField(translationKey, fallbackValue) {
  if (translationKey) {
    const translated = i18n.t(translationKey);
    if (translated !== translationKey) {
      return translated;
    }
  }

  if (typeof fallbackValue === 'string' && fallbackValue.includes('.')) {
    const fromFallbackKey = i18n.t(fallbackValue);
    if (fromFallbackKey !== fallbackValue) {
      return fromFallbackKey;
    }
  }

  return fallbackValue || '';
}

